// extracted by mini-css-extract-plugin
export var divider = "_ox-0";
export var systemMessage = "_ox-1";
export var systemMessageWrapper = "_ox-2";